<template>
  <div class="w-full">
    <FilterParameter
      v-for="parameter in categoryParameters"
      :key="parameter.idParameter"
      :parameter="parameter"
      query-code="c"
      :is-detail="isDetail"
    />
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import { useEnumStore } from '@stores/enum';
import FilterParameter from "@components/filter/filter-parameter";

defineProps({
  isDetail: {
    type: Boolean,
    default: false
  }
});

const enums = useEnumStore();
const routeCategory = useRouteCategory();
const parameters = ref([]);

const selectedCategories = computed(() => _.chain(routeCategory.idPostCategory.value || '').split(',').map(value => parseInt(value)).filter().value());

const categoryParameters = computed(() => _.filter(parameters.value, item => _.some(item.idCategories, cat => _.includes(selectedCategories.value, cat))));

const reload = (items) => {
  parameters.value = setupCatalogueParameters(items);
}

onMounted(() => reload(enums.catalogueParameters));

watch(() => enums.catalogueParameters, (items) => reload(items));

</script>
